import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import parse from 'url-parse';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

// eslint-disable-next-line react/prefer-stateless-function
class SitemapIndex extends Component {
  render() {
    if (
      this.props.htmlSitemapIndexPage.error &&
      this.props.htmlSitemapIndex.error
    ) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.htmlSitemapIndexPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const pathname = get(this.props, 'route.path');
    const htmlSitemapIndexReversed = [
      ...get(this.props, 'htmlSitemapIndex.urls')
    ].reverse();

    if (pathname === '/sitemap') {
      return (
        <section className="html-sitemap-index-page">
          <div className="html-sitemap-index-page__main">
            <h1 className="html-sitemap-index-page__heading">Site Map</h1>
            <div className="html-sitemap-index-page__body">
              {htmlSitemapIndexReversed.map(function sitemapLink(url) {
                const urlString = url.link.toString();
                const year = urlString.slice(-4);
                return (
                  <Link
                    to={url.link.replace(parse(url.link).origin, '')}
                    className="url--year"
                    key={url.link}
                  >
                    {year}
                  </Link>
                );
              })}
            </div>
          </div>
        </section>
      );
    }

    const year = get(this.props, 'match.params.year');

    return (
      <section className="html-sitemap-index-page">
        <div className="html-sitemap-index-page__main">
          <h1 className="html-sitemap-index-page__heading">
            <Link to="/sitemap">Site Map</Link> &gt; {year}
          </h1>
          <div className="html-sitemap-index-page__body">
            {this.props.htmlSitemapIndex.urls.map(function sitemapLink(url) {
              const parsedUrl = parse(url.link, true);
              return (
                <Link
                  to={url.link.replace(parsedUrl.origin, '')}
                  className="url--week"
                  key={url.link}
                >
                  {url.timeframe}
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    htmlSitemapIndexPage: state.htmlSitemapIndexPage || [],
    htmlSitemapIndex: get(state, 'htmlSitemapIndex.data') || { error: true }
  };
}

SitemapIndex.propTypes = {
  htmlSitemapIndexPage: PropTypes.shape({
    // eslint-disable-next-line
    error: PropTypes.shape({}),
    isLoading: PropTypes.bool
  }).isRequired,
  htmlSitemapIndex: PropTypes.shape({
    // eslint-disable-next-line
    urls: PropTypes.arrayOf(PropTypes.shape({})),
    error: PropTypes.bool
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(SitemapIndex));



// WEBPACK FOOTER //
// ./src/views/containers/pages/html_sitemap_index_page/html_sitemap_index_page.js